/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Fail_Delivery_ErrorInputs */

const vi_toast_order_fail_delivery_error = /** @type {(inputs: Toast_Order_Fail_Delivery_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật trạng thái thất bại`)
};

/**

* @param {Toast_Order_Fail_Delivery_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_fail_delivery_error = /** @type {((inputs?: Toast_Order_Fail_Delivery_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Fail_Delivery_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_fail_delivery_error(inputs)
});